export default __webpack_public_path__ + "static/media/page12.649e37a1.webp";